import LazyLoad from "vanilla-lazyload/dist/lazyload";

/* eslint-disable camelcase */

export default function(selector = "", callbackLoad = () => true) {

    function lazyLoadPolyfill() {

        $('.lazy-load-img source, img[data-src]').each(function() {

            $(this).parent('.lazy-load-img').css('overflow', 'hidden');

            $(this).attr('src', $(this).attr('data-src'));

            const srcSet = $(this).attr('data-srcset');
            if(srcSet) {
                $(this).attr('srcset', srcSet);
            }
        });
    }

    try {

        return new LazyLoad({
            elements_selector: `${selector} .lazy-load-img img, ${selector} img[data-src]`,
            class_loading: "lazy-load-img--loading",
            
            class_initial: "lazy-load-img--initial",
            data_src: "src",
            data_srcset: "srcset",
            unobserve_entered: true,
            callback_loaded: (elemt, evt) => {
                setTimeout(() => elemt.classList.add("lazy-load-img--loaded"), 50) // delay this because safari has issues with its lifecycle
                
            },
            callback_error: e => {
                console.log("error loading image")
            },
            callback_load: function (el) {

                // When a picture will be loaded lazily, resize it's placeholder according to picture's height
                //imgEl.closest(".lazy-load-img").css("padding-bottom", imgEl.height());

                callbackLoad(el);
            }
        });

    } catch(e) {
        lazyLoadPolyfill();
    }
}



// WEBPACK FOOTER //
// ./js/lazy-load/ImageLazyLoad.js